import React from 'react'
import APP_CONFIG from 'constants/appConfig'

function Footer() {
  return (
    <section className="app-footer">
      <div className="container-fluid">
        <span className="float-right">
          <span>
            © {APP_CONFIG.year} &nbsp;
            <a className="brand" target="_blank" href="/">
              {APP_CONFIG.brand}
            </a>
          </span>
        </span>
      </div>
    </section>
  )
}

export default Footer
